import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const AmazonDevice916: FC<Props> = (props) => (
  <Root viewBox="0 0 145.783 300.88" {...props}>
    <g data-name="\u30B0\u30EB\u30FC\u30D7 330" transform="translate(-43.86 -144.644)">
      <rect
        data-name="\u9577\u65B9\u5F62 784"
        width={145.783}
        height={300.88}
        rx={21.724}
        transform="translate(43.86 144.644)"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 786"
        width={34.733}
        height={3.524}
        rx={1.762}
        transform="translate(97.566 430.669)"
      />
      <path data-name="\u9577\u65B9\u5F62 792" fill="#fc3" d="M49.837 204.761h134.506v169.506H49.837z" />
      <circle
        data-name="\u6955\u5186\u5F62 493"
        cx={5.232}
        cy={5.232}
        r={5.232}
        transform="translate(155.289 402.296)"
        fill="#e7e7e7"
      />
      <circle
        data-name="\u6955\u5186\u5F62 494"
        cx={5.232}
        cy={5.232}
        r={5.232}
        transform="translate(66.93 402.296)"
        fill="#e7e7e7"
      />
      <circle
        data-name="\u6955\u5186\u5F62 495"
        cx={5.232}
        cy={5.232}
        r={5.232}
        transform="translate(111.212 402.296)"
        fill="#e7e7e7"
      />
    </g>
  </Root>
);

const Root = styled('svg')();

export default AmazonDevice916;
